import createCardItem from './createCardItem';
import getCardRole from '../../utils/data/getCardRole';
import Activity from '../../schema/Activity';
import CardRole from '../../schema/innerSchema/CardRole';
import CardItem from '../../schema/viewSchema/CardItem';
import Entity from '../../schema/Entity';
import TxpImages from '../../schema/configSchema/TxpImages';
import TxpStrings from '../../schema/configSchema/TxpStrings';

export default function createCardsNoBusStop(
    activities: Activity[],
    entities: { [entityId: string]: Entity },
    entitiesPrimaryHash: any,
    showEnhancedLocation: boolean,
    txpStrings: TxpStrings,
    txpImages?: TxpImages,
    calendarEventIds?: any[],
    cardRole?: CardRole
) {
    let cardItems: CardItem[] = [];
    activities.forEach(activityItem => {
        let currentEntity = entities[activityItem.entityId];
        // if cardRole enum is null or undefined, derive the cardRole
        let txpCardRole =
            cardRole || cardRole === 0 ? cardRole : getCardRole(activityItem, entitiesPrimaryHash);
        // when cardRole is null, no need to make a card.
        if (txpCardRole != null) {
            let card = createCardItem(
                activityItem,
                currentEntity,
                false /** not a bus-stop */,
                showEnhancedLocation,
                txpStrings,
                txpImages,
                txpCardRole,
                calendarEventIds
            );
            cardItems.push(card);
        }
    });
    return cardItems;
}
